import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Main from "@/views/main/Main.vue";
import Login from "@/views/login/Login.vue";
import ChangePassword from "@/views/change-password/ChangePassword.vue";

Vue.use(Router);

const router: Router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/change-password/:token",
      name: "changePassword",
      component: ChangePassword,
      props: true
    },
    {
      path: "/integration/:token",
      name: "integration",
      component: () => import("./views/integration/Integration.vue"),
      props: true
    },
    {
      path: "/",
      name: "main",
      component: Main,
      // this component works like a layout so it will not be considered a valid route
      redirect: "farms-home",
      meta: { requiresAuth: true },
      children: [
        {
          path: "home",
          name: "home",
          redirect: "farms-home"
        },
        {
          path: "owners",
          name: "owners",
          component: () => import("./views/home/Home.vue")
        },
        {
          path: "farms-home",
          name: "farms-home",
          component: () => import("./views/farms-home/FarmsHome.vue")
        },
        {
          path: "toolbox",
          name: "toolbox",
          component: () => import("./views/toolbox/Toolbox.vue"),
        },
        {
          path: "analitica",
          name: "analitica",
          component: () => import("./views/analitica/Analitica.vue"),
          meta: {requiresAdmin: true}
        },
        {
          path: "sentinela",
          name: "sentinela",
          component: () => import("./views/sentinela/Sentinela.vue"),
          meta: {requiresAdmin: true}
        },
        {
          path: "farms/:ownerUuid?",
          name: "farms",
          component: () => import("./views/farms/Farms.vue"),
          props: true
        },
        {
          path: "analyses/:uuid/:source?",
          name: "analyses",
          component: () => import("./views/analyses/Analyses.vue"),
          props: true
        },
        {
          path: "me",
          name: "me",
          component: () => import("./views/user/User.vue")
        },
        {
          path: "me/change-password",
          name: "meChangePassword",
          component: () =>
            import("./views/user-change-password/UserChangePassword.vue")
        },
        {
          path: "compare-farms-owners/:uuid/:source?",
          name: "compare-farms-owners",
          component: () => import("./views/compare-farms-owners/CompareFarmsOwners.vue"),
          props: true
        },

        {
          path: "monitoring/:uuid/:source?",
          name: "monitoring",
          component: () => import("./views/monitoring/Monitoring.vue"),
          props: true
        },
        
        {
          path: "crop-update/:analysisUuid/:farmAnalysisUuid/:year",
          name: "crop-update",
          component: () => import("./views/crop-update/CropUpdate.vue"),
          props: true
        },
      ]
    }
  ]
});

// auth navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated: boolean = store.getters["auth/isAuthenticated"];
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: "login", query: { redirect_to: to.fullPath } });
    } else {
      next();
    }
  } else if (
    isAuthenticated &&
    to.matched.some(record => record.name === "login")
  ) {
    next({ name: "farms-home" });
  } else {
    next();
  }
});

// admin navigation guard
router.beforeEach((to, from, next) => {
  const isAdminUser: boolean = store.getters["user/isAdminUser"];
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!isAdminUser) {
      next(false);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
